import {Button, Group, Notification, Stack, Text} from "@mantine/core";
import {
    ChatStopReason,
    StreamErrorMessage,
    StreamErrorType,
} from "../../../../types";
import IconMoodSad from "../../../../assets/mood-sad.svg?react";
import IconBarrierBlock from "../../../../assets/barrier-block.svg?react";
import IconArrowLeft from "../../../../assets/arrow-left.svg?react";
import {chatApi} from "../../chatApi";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../app/hooks";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {rateLimitReset} from "../../chatSlice";
interface Props {
    value?: StreamErrorMessage;
    onResend: () => void;
    onExit: () => void;
    threadId: string;
}

export const ErrorReason: React.FC<Props> = ({
    value,
    onResend,
    onExit,
    threadId,
}) => {
    const transientChat = useAppSelector((state) => state.transientChat);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [deleteThread, {isLoading}] =
        chatApi.endpoints.deleteThread.useMutation();

    const handleCorruptThread = () => {
        deleteThread(threadId).then(() => {
            onExit();
        });
    };

    if (!value) {
        return null;
    }

    return (
        <>
            {value.errorType === StreamErrorType.Unknown &&
                !value.message.includes("content_filter") && (
                    <Notification
                        icon={<IconMoodSad />}
                        color="red"
                        title={t("error.unknown.title")}
                        withCloseButton={false}
                    >
                        <Group>
                            <Text size="sm">{t("error.unknown.body")}</Text>
                            <Button
                                variant="outline"
                                size="xs"
                                color="gray"
                                onClick={onResend}
                            >
                                {t("common.tryAgain")}
                            </Button>
                        </Group>
                    </Notification>
                )}
            {value.errorType === StreamErrorType.Unknown &&
                value.message.includes("content_filter") && (
                    <Notification
                        icon={<IconMoodSad />}
                        color="red"
                        title={t("error.contentFilter.title")}
                    >
                        <Stack>
                            <Text size="sm">
                                {t("error.contentFilter.body")}
                            </Text>
                            <Button
                                variant="outline"
                                size="xs"
                                color="gray"
                                onClick={handleCorruptThread}
                            >
                                {t("common.goBack")}
                            </Button>
                        </Stack>
                    </Notification>
                )}
            {value.errorType === StreamErrorType.ContextLengthExceeded && (
                <Notification
                    icon={<IconMoodSad />}
                    color="red"
                    title={t("error.contextLength.title")}
                    withCloseButton={false}
                >
                    <Stack>
                        <Text size="sm">{t("error.contextLength.body")}</Text>
                        <Button
                            variant="outline"
                            size="xs"
                            color="gray"
                            onClick={onExit}
                            leftSection={<IconArrowLeft height="18px" />}
                        >
                            {t("common.goBack")}
                        </Button>
                    </Stack>
                </Notification>
            )}
            {value.errorType === StreamErrorType.RateLimitExceeded &&
                transientChat.rateLimitCount > 1 && (
                    <Notification
                        icon={<IconMoodSad />}
                        color="red"
                        title={t("error.rateLimit.title")}
                        withCloseButton={false}
                    >
                        <Stack>
                            <Text size="sm">{t("error.rateLimit.body")}</Text>
                            <Button
                                variant="outline"
                                size="xs"
                                color="gray"
                                onClick={onResend}
                            >
                                {t("common.tryAgain")}
                            </Button>
                        </Stack>
                    </Notification>
                )}
        </>
    );
};
